import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as r } from "./index.es36.js";
var d = [r.green4, r.green5, r.pearl4, r.pearl5, r.blue4, r.blue5, r.purple4, r.purple5, r.pink4, r.pink5, r.red4, r.red5, r.orange4, r.orange5, r.yellow3, r.yellow4, r.gray5, r.gray7];
export { d as DEFAULT_CHART_COLORS };